export class GetChannelsBalanceReportReqData {
    branchId: number = -1;
    installationNames: string[] = [];
    startDate: Date = null;
    endDate: Date = null;
    // userGroupIds: number[] = [];
    // shiftNumbers: string[] = [];

    constructor() {
        this.endDate = new Date();
        this.startDate = new Date();
        this.startDate.setHours(0, 0, 0, 0);
        this.endDate.setHours(23, 59, 59, 0);
    }

    public GetReqDataPayload(): GetChannelsBalanceReportReqData {
        let res = new GetChannelsBalanceReportReqData();
        res.branchId = this.branchId;

        this.installationNames.forEach((element) => {
            res.installationNames.push(element);
        });

        res.startDate = new Date(
            Date.UTC(
                this.startDate.getFullYear(),
                this.startDate.getMonth(),
                this.startDate.getDate(),
                this.startDate.getHours(),
                this.startDate.getMinutes(),
                this.startDate.getSeconds()
            )
        );

        res.endDate = new Date(
            Date.UTC(this.endDate.getFullYear(), this.endDate.getMonth(), this.endDate.getDate(), this.endDate.getHours(), this.endDate.getMinutes(), this.endDate.getSeconds())
        );
        return res;
    }
}
